module.exports = __webpack_public_path__ + "img/Logo-Colegio1.bd50702e.png";